<div class="card">
    <div class="content-box--title" *ngIf="title">
        <h3>{{title}}</h3>
    </div>
    <div class="content-box--content">
        <ng-content></ng-content>
    </div>
</div>
